import router from '~/common/router'
import AccountService from '~/services/account'
import NProgress from 'nprogress' // Progress 进度条
import {Notification} from 'element-ui'
import store from '~/store/index'
import {APP} from "~/config/app";

const LOGIN_URL = '/login';

/**
 * 访问控制
 */
export default class AccessControl {

    constructor(props) {

        this.userIdentity = AccountService;
        this.exceptRouters = props.exceptRouters;

        this.beforeAction();

        //console.log("isGuest : ", this.userIdentity.isGuest());
        //console.log("enableAuth :", APP.enableAuthPermission);
    }

    beforeAction() {
        router.beforeEach((to, from, next) => {
            NProgress.start()
            // 检查 token 是否已过期
            if (this.userIdentity.isExpire()) {
                // 如果过期尝试刷新token以便保持登录 只会尝试一次不能刷新成功将被踢下线
                store.dispatch('refreshToken').then(res => {
                    this.checkIdentity(to, from, next);
                })
            } else {
                this.checkIdentity(to, from, next);
            }

            // 每次刷新或者切换页面都
            store.dispatch('setGlobalMessageState', true);

        })

        router.afterEach(() => {
            NProgress.done() // 结束Progress
        });
    }

    checkIdentity(to, from, next) {
        // 已登录
        if (!this.userIdentity.isGuest()) {
            if (to.path === LOGIN_URL) {
                // 已登录状态访问登录页强制重定向到系统首页
                next({path: '/'});
            } else {

                // 如果请求的路由与当前Module不一致则切换到路由所在Module
                if (to.meta.module != store.state.app.moduleId) {
                    store.dispatch('SwitchModuleId', to.meta.module)
                }

                // 继续访问
                store.dispatch('getUserIdentity').then((res) => { // 拉取用户信息

                    // 验证是否有访问权限如果没有则跳转至 403 页面
                    if (
                        APP.enableAuthPermission
                        && !this.userIdentity.canAccess(to.path, to.meta)
                        && this.exceptRouters.indexOf(to.path) < 0) {
                        next({path: '/403'});

                    } else {
                        next();
                    }
                }).catch(() => {
                    store.dispatch('clearCache').then(() => {
                        Notification.error({
                            title: '验证失败',
                            message: '身份信息验证失败',
                            duration: 3000,
                        });
                        next({path: '/login'})
                    })
                })
            }
        } else {

            if (this.exceptRouters.indexOf(to.path) !== -1) {
                if (to.path !== LOGIN_URL) {
                    next({path: LOGIN_URL});
                }
                next();
            } else {
                Notification.warning({
                    title: '提示',
                    message: '进入系统前必须先登录',
                    duration: 3000,
                });
                // 未登录强制跳转到登录页面
                next({path: LOGIN_URL});
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/common/filters/AccessControl.js